import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  clientTierApi,
  type ClientTierConfig,
  type CreateClientTierInput,
  type UpdateClientTierInput,
} from '../api/clientTierApi';

const KEY = ['client-tier-configs'] as const;

export const useClientTierConfigs = () => {
  return useQuery({
    queryKey: KEY,
    queryFn: clientTierApi.list,
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreateClientTier = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateClientTierInput) => clientTierApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useUpdateClientTier = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateClientTierInput }) =>
      clientTierApi.update(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useDeleteClientTier = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => clientTierApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useReorderClientTiers = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (orderedIds: string[]) => clientTierApi.reorder(orderedIds),
    onSuccess: (data) => qc.setQueryData<ClientTierConfig[]>(KEY, data),
  });
};
